import api from './jsonapi'
import { dateYMD } from '../lib/formats'

/*
Fetches a CSV report from /project-types/:id/simple-report
Returns a Blob object with the file contents
*/
const projectTypeReport = (projectTypeId, startDate, endDate, quoteState) => {
  startDate = startDate ? dateYMD(startDate) : ''
  endDate = endDate ? dateYMD(endDate) : ''
  const path =
    `/project-types/${projectTypeId}/simple-report` +
    `?startDate=${startDate}&endDate=${endDate}&quoteState=${quoteState}`

  return new Promise((resolve, reject) => {
    api
      .get(path)
      .then(response => {
        // Make filename
        let filename = 'project-type-report'
        if (startDate) filename += `-from-${startDate}`
        if (endDate) filename += `-to-${endDate}`
        if (quoteState) filename += `-${quoteState}-quotes`
        filename += '.csv'

        // Make content blob
        const contents = new Blob([response.data], { type: 'text/csv' })

        resolve({ filename, contents })
      })
      .catch(error => reject(error))
  })
}

export { projectTypeReport }



// WEBPACK FOOTER //
// ./src/stores/csv_reports.js